__webpack_require__.p = "/Egen-Insamling/app-assets/";